// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__14747","title":"ClientCherryInfo_title__2uVs0","itemText":"ClientCherryInfo_itemText__1mW1D"};